import './bootstrap'
import Vue from 'vue'
import router from '@/router/index'
import store from '@/store/index'
import App from './App.vue'
import './plugins'
import BootstrapVue from 'bootstrap-vue'

//DAVID
import './readynet/globals'


Vue.use(BootstrapVue)
// const app = new Vue({
export const vm = new Vue({
	el: '#app',
	router,
	store,
	render: h => h(App)
});

// export default app;
